/**
 * Escapes characters that have special meaning in Telegram's MarkdownV2 format.
 * 
 * See: https://core.telegram.org/bots/api#markdownv2-style
 * 
 * Characters to escape: _ * [ ] ( ) ~ ` > # + - = | { } . !
 * 
 * @param text The text to escape.
 * @returns The escaped text.
 */
export function escapeMarkdownV2(text: string): string {
  // Use replace with a regex that matches any character needing escaping
  // and prepend a backslash to it.
  return text.replace(/([_*[\]()~`>#+\-=|{}.!\\])/g, '\\$1');
} 